/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Map of eligibility/attestation values keyed by Challenge.eligibilityCheckboxes[].key.
 * @export
 * @interface ChallengeEligibilityMap
 */
export interface ChallengeEligibilityMap {
    [key: string]: boolean;
}

/**
 * Check if a given object implements the ChallengeEligibilityMap interface.
 */
export function instanceOfChallengeEligibilityMap(value: object): value is ChallengeEligibilityMap {
    return true;
}

export function ChallengeEligibilityMapFromJSON(json: any): ChallengeEligibilityMap {
    return ChallengeEligibilityMapFromJSONTyped(json, false);
}

export function ChallengeEligibilityMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeEligibilityMap {
    return json;
}

export function ChallengeEligibilityMapToJSON(json: any): ChallengeEligibilityMap {
    return ChallengeEligibilityMapToJSONTyped(json, false);
}

export function ChallengeEligibilityMapToJSONTyped(value?: ChallengeEligibilityMap | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

